import type { PokePlayerStats } from '@/services/pokemon';

interface PlayerStatsPanelProps {
  stats: PokePlayerStats;
}

interface StatTile {
  label: string;
  value: string | number;
  sub?: string;
}

export const PlayerStatsPanel = ({ stats }: PlayerStatsPanelProps) => {
  const tiles: StatTile[] = [
    {
      label: 'Capturés',
      value: (stats.totalCaught ?? 0).toLocaleString('fr-FR'),
    },
    {
      label: 'Shinies',
      value: (stats.shinyCount ?? 0).toLocaleString('fr-FR'),
    },
    {
      label: 'Légendaires',
      value: (stats.legendaryCount ?? 0).toLocaleString('fr-FR'),
    },
    {
      label: 'Expéditions gagnées',
      value: (stats.expeditionsWon ?? 0).toLocaleString('fr-FR'),
    },
    {
      label: 'Série actuelle',
      value: stats.catchStreak ?? 0,
      sub: `record : ${stats.maxCatchStreak ?? 0}`,
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5">
      {tiles.map((tile) => (
        <div
          key={tile.label}
          className="bg-raised rounded-2xl p-3 text-center"
        >
          <p className="text-content/50 mb-1 text-xs">{tile.label}</p>
          <p className="font-lexend text-content text-lg font-bold leading-none">
            {tile.value}
          </p>
          {tile.sub && (
            <p className="text-content/40 mt-1 text-[10px]">{tile.sub}</p>
          )}
        </div>
      ))}
    </div>
  );
};
